
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ThresholdSlider extends Vue {
    @Prop() label!: string;
    @Prop() value!: number;

    get tickLabels() {
        return ['--', '-', '0', '+', '++'];
    }

    updateValue(newValue: number) {
        this.$emit('input', newValue);
    }
}
